// Amphis-specific feature stylers — kept out of the generic <map-box> /
// <map-vector-layer> code. Registered into the shared registry so views
// can opt in via `<map-vector-layer style-key="amphis-observations">`.
//
// `species_name` colours are taken from server-rendered hints elsewhere
// on the page: an element with class "dataset species_name" carrying
// data-species-name="<name>" data-graph-colour="<rgb-triplet>". When no
// hint is present the styler falls back to the generic geometry-type
// style.

import {Fill, Stroke, Style, Circle} from 'ol/style.js';
import {mapStyle, registerFeatureStyle} from './map-styles.js';


const speciesCache = {};

function speciesStyle(speciesName) {
  if (!speciesName) return null;
  if (speciesCache[speciesName] !== undefined) return speciesCache[speciesName];

  const datasetElement = document.querySelector(
    `.dataset.species_name[data-graph-colour][data-species-name="${CSS.escape(speciesName)}"]`
  );
  if (!datasetElement) {
    speciesCache[speciesName] = null;
    return null;
  }

  const clr = datasetElement.dataset.graphColour;
  const style = new Style({
    image: new Circle({
      fill:   new Fill({color: `rgba(${clr},0.4)`}),
      radius: 5,
      stroke: new Stroke({color: `rgba(${clr},0.9)`, width: 1}),
    }),
  });
  speciesCache[speciesName] = style;
  return style;
}


registerFeatureStyle('amphis-observations', (feature) => {
  return speciesStyle(feature.get('species_name'))
      || mapStyle[feature.getGeometry().getType()]
      || mapStyle.normal;
});
